module.exports = __webpack_public_path__ + "static/media/pw.1bcf7511.webp";